<div class="dialog-content-wrapper" *ngIf="cliente">
  <div class="detail-card">
    <div class="detail-header">
      <div class="header-icon">
        <i class="pi pi-user"></i>
      </div>
      <div class="header-info">
        <h2 class="detail-title">{{ cliente.apelido }}</h2>
        <p class="detail-subtitle">{{ getTipoDocumento(cliente.cpfCnpj) }}</p>
      </div>
    </div>

    <div class="info-section">
      <div class="section-title">
        <i class="pi pi-info-circle"></i>
        <span>Informações do Cliente</span>
      </div>
      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-id-card"></i><span>CPF/CNPJ</span></div>
          <div class="detail-value">{{ formatarCpfCnpj(cliente.cpfCnpj) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-phone"></i><span>Telefone</span></div>
          <div class="detail-value">{{ formatarTelefone(cliente.telefone) }}</div>
        </div>

        <div class="detail-item full-width">
          <div class="detail-label"><i class="pi pi-envelope"></i><span>E-mail</span></div>
          <div class="detail-value">{{ cliente.email || 'Não informado' }}</div>
        </div>

        <div class="detail-item full-width">
          <div class="detail-label"><i class="pi pi-map-marker"></i><span>Endereço</span></div>
          <div class="detail-value">
            <span *ngIf="enderecoCompleto(cliente)" class="address-text">{{ enderecoCompleto(cliente) }}</span>
            <span *ngIf="!enderecoCompleto(cliente)" class="no-data">Não informado</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
